// import { styled } from "stitches";;
import {styled} from "stitches";

export const Page = styled("div", {
	display: "flex",
	flex: 1,
	flexDirection: "column",
	padding: "$3",
	overflowY: "auto",
	variants: {
		centerContainer: {
			true: {
				margin: "0 auto",
				width: 1280,
				maxWidth: "100%",
			},
		},
		centerContent: {
			true: {
				alignItems: "center",
				justifyContent: "center",
			},
		},
		fullScreen: {
			true: {
				padding: 0,
				margin: 0,
			}
		},
		limitWidth: {
			true: {
				maxWidth: 1000,
			},
		},
	},
});

export const NoResults = styled("div", {
	width: "100%",
	display: "flex",
	justifyContent: "center",
});